import { ReactNode } from 'react';

import { Box } from '@mui/material';

const sizes = {
    small: '40px',
    medium: '80px',
    large: '96px',
};

type Props = {
    children: ReactNode;
    size?: 'small' | 'medium' | 'large';
};

export const ImageCircle = ({ children, size = 'medium' }: Props) => {
    const sizePx = sizes[size];

    return (
        <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="50%"
            bgcolor={(theme) => theme.palette.white.main}
            border="1px solid #E0E7EE"
            boxShadow="0px 0px 22px 2px rgba(0, 0, 0, 0.06), 0px 0px 2px 0px rgba(37, 47, 64, 0.10)"
            width={sizePx}
            height={sizePx}
        >
            {children}
        </Box>
    );
};
